import { z } from 'zod';

import { uidSchema } from './ids';

/**
 * Timestamps are plain `Date` inside the domain. Translating to and from
 * Firestore `Timestamp` is the job of the converters in the infrastructure
 * layer, which keeps `core/` free of any Firebase dependency.
 */
export const timestampSchema = z.date();

/** Creation and modification trail carried by every stored document. */
export const auditSchema = z.object({
  createdAt: timestampSchema,
  createdBy: uidSchema,
  updatedAt: timestampSchema,
  updatedBy: uidSchema,
});

export type Audit = z.infer<typeof auditSchema>;

/** Calendar day without a time component, e.g. the tournament date. */
export const isoDateSchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Erwartet wird ein Datum im Format JJJJ-MM-TT');

export type IsoDate = z.infer<typeof isoDateSchema>;

/** Non-negative whole number, the shape most counters in this domain take. */
export const countSchema = z.number().int().min(0);

/** Whole number of at least one, for sizes that cannot sensibly be zero. */
export const positiveIntSchema = z.number().int().min(1);
